import Env from 'src/environmentVariables/EnvironmentVariables';
import captureException from './captureException';

export async function fetchPythCranks(
	source: 'pythLazer' | 'pythPull',
	feedIds: number[] | string[]
): Promise<{ success: boolean; body?: { data: string }; status?: number }> {
	try {
		const response = await fetch(
			`${Env.dlobServerHttpUrl}/${source}?feedIds=${feedIds.join(',')}`
		);
		if (!response.ok) {
			return { success: false, status: response.status };
		}
		return {
			success: true,
			body: await response.json(),
			status: response.status,
		};
	} catch (e: any) {
		captureException(e);
		console.error(e, `Caught error pyth crank data`);
		return { success: false };
	}
}
